module.exports = __webpack_public_path__ + "static/media/batonage.f8545354.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/batonage.jpg
 ** module id = 268
 ** module chunks = 0
 **/